module.exports = __webpack_public_path__ + "media/tang_2.21acdd07.mp4";